module.exports = __webpack_public_path__ + "img/bh01.26739f0a.jpg";